<!--
 * @Author: your name
 * @Date: 2021-04-14 11:14:14
 * @LastEditTime: 2021-05-26 17:17:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/business/order/index.vue
-->
<template>
  <div class="orderList">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input @keyup.enter.native="onSubmit" style="width: 230px" v-model="formInline.orderName" clearable placeholder="订单名称/编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input @keyup.enter.native="onSubmit" style="width: 230px" v-model="formInline.createUserName" clearable placeholder="下单人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formInline.orderStatus" clearable placeholder="订单状态">
          <el-option v-for="item in ztList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">搜 索</el-button>
      </el-form-item>
    </el-form>
    <div v-loading="loading">
      <el-table size="small" :data="tableData" style="width: 100%">
        <el-table-column align="center" prop="code" label="订单编号"></el-table-column>
        <el-table-column align="center" prop="name" label="订单名称">
          <template slot-scope="scope">
            <div class="name_box">
              <el-link target="_blank" :underline="false" @click="orderNameCick(scope.row.id,scope.row.name)">
                {{scope.row.name}}
                <i class="el-icon-edit" style="color:#409EFF;"></i>
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="numberCount" label="账号数量"></el-table-column>
        <el-table-column align="center" prop="fansCount" label="覆盖粉丝总数"></el-table-column>
        <el-table-column label="报价总计" align="center" prop="priceCount">
          <template slot="header" slot-scope="scope">
            <div style=" display: flex;align-items: center;  justify-content: center;">
              报价总计 <el-tooltip class="item" effect="light" content="该订单涉及账号的报价累计总和" placement="bottom">
                <i class="iconfont icon-tishi" style="color:#303133; margin-left: 10px;font-size:12px"></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.priceCount }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="date" width="180" label="下单信息">
          <template slot-scope="scope">
            <div>
              <div>{{scope.row.createUserName}}</div>
              <div>{{scope.row.createTime}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="orderStatus" label="订单状态">
          <template slot-scope="scope">
            {{orderStatus[scope.row.orderStatus]}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="small" @click="detailsClick(scope.row.id,scope.row.name,scope.row.code)">查看</el-button>
              <el-button size="small" v-if="scope.row.orderStatus===4" style="color:;" type="text" @click="deleteClick(scope.row.id)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="text-align:right;padding-bottom:20px;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 订单名称 -->
    <el-dialog
      title="订单名称修改"
      :visible.sync="dialogVisible"
      width="30%">
      <div style="margin-top:-20px;">
        订单名称:<el-input maxlength="25" show-word-limit style="margin-top:10px;" v-model="orderName" placeholder="请输入内容"></el-input>
      </div>
      <div style="text-align:center;margin-top:20px;">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrderNameClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { all_order_list,update_order } from "@/api/order/index";
export default {
  data() {
    return {
      loading:false,
      autofocus:false,
      inputShow:false,
      formInline: {
		  createUserName:'',
        orderName:"",
        orderStatus:"",
        pageNum: 1,
        pageSize: 10,
      },
      detailsType:1,
      textarea:"",
      dialogVisible:false,
      orderName:"",//订单名称
      total:0,
      ztList: [
        { value: 4, label: "待投放" },
        { value: 1, label: "待接单" },
        { value: 2, label: "部分接单" },
        { value: 3, label: "全部接单" },
        { value: 5, label: "全部拒单" },
        { value: 0, label: "全部完成" },
      ],
      orderStatus:['全部完成','待接单','部分接单','全部接单','待投放','全部拒单'],
      tableData: [],
      inputIndex:''
    };
  },
  methods: {
    orderNameCick(id,name){
      this.dialogVisible = true;
      this.orderName = name;
      this.orderId = id;
    },
    saveOrderNameClick(){
      if(!this.orderName){
        this.$message.error('请输入订单名称');
        return
      }
      //调用接口
      update_order({
        name:this.orderName,
        id:this.orderId,
        deleteFlag:0
      }).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '订单名称修改成功!',
            type: 'success'
          });
          this.all_order_list()
          this.dialogVisible = false
        }else{
          this.$message.error(res.msg);
        }
        console.log('======删除接口返回========',res)
      })
    },
    all_order_list(){
      this.loading = true;
      all_order_list(this.formInline).then(res=>{
        this.tableData = res.data;
        this.total = res.total
        this.loading = false;
      })
    },
    //查看
    detailsClick(id,name,code){
      let router = this.$router.resolve({
          path: "/internal/details",
          query: {
            id,
            name,
            code
          },
      });
      window.open(router.href, "_blank");
    },
    //删除
    deleteClick(id){
      this.$confirm('确认删除吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        update_order({id:id,deleteFlag:1}).then(res=>{
          if(res.code === 1){
            this.$message({
              message: '删除成功!',
              type: 'success'
            });
            this.all_order_list()
          }else{
            this.$message.error(res.msg);
          }
          console.log('======删除接口返回========',res)
        })
      }).catch(() => {
        
      });
    },
    //查询
    onSubmit() {
      this.formInline.pageNum = 1;
      this.all_order_list()
    },
    editClick(){},
    handleSizeChange(val) {
      this.formInline.pageSize = val
      this.all_all_order_list()
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val
      this.all_all_order_list()
    }
  },
  computed: {},
  mounted() {
    this.all_order_list()
  },
};
</script>
<style lang="scss" scoped>
.orderList {
  margin-top: 10px;
  padding: 20px;
  background: #fff;
}
.name_box{
  display: flex;
  align-items: center;
  justify-content: center;
}
.inputYn{
  border:0;
  height: 30px;
}
.data_disp{
  display: flex;
  align-items: center;
}
.orderNameText:hover{
  cursor: pointer;
}
</style>